"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureEnabled = exports.selectFeatureFlagsSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const selectFeatureFlagsSlice = (state) => state.featureFlags;
exports.selectFeatureFlagsSlice = selectFeatureFlagsSlice;
const isFeatureEnabled = (featureId) => (0, toolkit_1.createSelector)(exports.selectFeatureFlagsSlice, (featureFlags) => { var _a; return (_a = featureFlags.data[featureId]) !== null && _a !== void 0 ? _a : false; });
exports.isFeatureEnabled = isFeatureEnabled;
//# sourceMappingURL=selectors.js.map